import axios from 'axios'
import config from '@/config'
import applyUrlTemplate from './applyUrlTemplate'
import applyDefaultParams from './applyDefaultParams'
import { applyCacheResuest, applyCacheResponse } from './cache'
import store from '@/store'

import normalizeAxiosError, {
// SERVER_ERROR,
// TIMEOUT_ERROR,
// NETWORK_ERROR
} from './normalizeAxiosError'
import router from '@/router'

const API_TIMEOUT = 300000 // 300s
// const API_TIMEOUT = 5000 // 30s

const tdealApiV2 = axios.create({
  baseURL: config.tdealApiBaseUrlV2,
  timeout: API_TIMEOUT
})

tdealApiV2.interceptors.request.use(applyCacheResuest)
tdealApiV2.interceptors.request.use(applyUrlTemplate)
tdealApiV2.interceptors.request.use(applyDefaultParams)

tdealApiV2.interceptors.response.use(applyCacheResponse)
tdealApiV2.interceptors.response.use(null, normalizeAxiosError)
tdealApiV2.interceptors.response.use(null, function (err) {
  // if (err.code === TIMEOUT_ERROR || err.code === NETWORK_ERROR) {
  //   // soter.commit('error...', err)
  // }
  // if (err.code === SERVER_ERROR) {
  //   // soter.commit('error...', err)
  //   if (router.app._route.query.isDebug !== 'true') {
  //     router.push({path: '/etc/dataerror'})
  //   }
  // }
  router.push({path: '/etc/dataerror'})
  return Promise.reject(err)
})

tdealApiV2.interceptors.response.use(function (response) {
  if (response.data.info && response.data.info.result && response.data.info.result.code === 'FAIL') {
    if (response.data.info.result.message === 'permission denied') {
      alert('접근 권한이 없습니다.')
      router.push({path: store.getters['authentication/getUserInitPage']})
    }
  } else {
    if (store.getters['authentication/getRefreshTime'] === '') {
      if (response.config.url !== 'sso/refresh')window.incrossSSO.refresh()
    } else {
      let afterRefreshTime = new Date().getTime()
      let beforeRefreshTime = store.getters['authentication/getRefreshTime'].getTime()
      // router refresh 후 3초 지났을때 refresh 하도록 간격 제어
      if (afterRefreshTime - beforeRefreshTime >= 3000) {
        if (response.config.url !== 'sso/refresh')window.incrossSSO.refresh()
      }
    }
    return response
  }
}, async function (error) {
  router.push({path: '/etc/dataerror'})
  return Promise.reject(error)
})

export default tdealApiV2
